import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=0eca8650&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"
import style0 from "./Game.vue?vue&type=style&index=0&id=0eca8650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../gotti-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca8650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\joevi\\source\\repos\\gotti-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eca8650')) {
      api.createRecord('0eca8650', component.options)
    } else {
      api.reload('0eca8650', component.options)
    }
    module.hot.accept("./Game.vue?vue&type=template&id=0eca8650&scoped=true&", function () {
      api.rerender('0eca8650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "builds/_prebuild/Client/components/Game.vue"
export default component.exports